module.exports = __webpack_public_path__ + "static/media/level-special-off.8e1a07b8.png";